export default __webpack_public_path__ + "static/media/EAST2480.34I-34287_-18543_0.26a13ff0.jpg";